import { z } from 'zod';
import { IllegalArgumentError } from 'faro-common-model';
import { uuidish } from '../../utils/uuidish.js';
import { nullishToUndefined } from '../../utils/nullishToUndefined.js';
/**
 * Validation schema for {@link VeevaCaseReportFormImport} entity.
 */
const veevaCaseReportFormImportValidationSchema = z.object({
    id: uuidish.describe('id is required'),
    environmentId: z
        .string()
        .endsWith('__v')
        .describe('Veeva Vault CDMS environment for library CRFs; must end in "__v"'),
    tenantId: uuidish.describe('tenantId is required'),
    status: z.enum(['started', 'success', 'failure']).describe('status is required'),
    statusMessage: z.string().nullish().transform(nullishToUndefined).optional(),
    data: z.any().nullish().transform(nullishToUndefined).optional(),
    created: z.date().describe('created is required'),
    createdBy: uuidish.describe('createdBy is required'),
    updated: z.date().nullish().transform(nullishToUndefined).optional(),
});
export function toVeevaCaseReportFormImport(input) {
    const result = veevaCaseReportFormImportValidationSchema.safeParse(input);
    if (!result.success) {
        throw new IllegalArgumentError(`Invalid VeevaCaseReportFormImport object. ${result.error.message}`);
    }
    return result.data;
}
//# sourceMappingURL=veeva-case-report-form-import.js.map